import Color from 'color';
import styled from 'styled-components';

import {ms, msi} from '../../../../styles/normalizeSize';
import {getColor} from '../../../../styles/utils';
import {Button} from '../../../../uikit/Button';
import {Image} from '../../../../uikit/Image';
import {Rect, Svg} from '../../../../uikit/Svg';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';

export const Container = styled(View)`
  padding: ${ms(10)} ${ms(15)};
  display: flex;
  flex-direction: row;
`;

export const AvatarContainer = styled(View)`
  position: relative;
  margin-right: ${ms(10)};
  align-self: flex-start;
`;

export const Avatar = styled(Image)`
  width: ${ms(46)};
  height: ${ms(46)};
  border-radius: ${ms(23)};
`;

export const SubAvatar = styled(Image)`
  width: ${ms(22)};
  height: ${ms(22)};
  border-radius: ${ms(11)};
  border: 1px solid ${getColor('border1')};
  position: absolute;
  right: ${ms(-2)};
  bottom: ${ms(-2)};
  background-color: ${getColor('background1')};
`;

export const IconContainer = styled(View)`
  width: ${ms(22)};
  height: ${ms(22)};
  border-radius: ${ms(22)};
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: ${ms(-2)};
  bottom: ${ms(-2)};
  elevation: 5;
  box-shadow: 0 1px 4px
    ${p => Color(p.theme.color.v2.global1).alpha(0.32).toString()};
  overflow: hidden;
  background-color: ${getColor('background.white')};
`;

export const IconGradientSvg = styled(Svg)`
  position: absolute;
  inset: 0;
`;

export const IconGradientRect = styled(Rect).attrs({
  height: msi(22),
  width: msi(22),
})``;

export const icon = {
  height: msi(16),
  width: msi(16),
  zIndex: 1,
};

export const ContentContainer = styled(View)`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Title = styled(Text)`
  font-size: ${ms(13)};
  line-height: ${ms(16)};
  letter-spacing: ${ms(-0.46)};
  color: ${getColor('text1')};
`;

export const HighlightedTitle = styled(Title)`
  color: ${getColor('global1')};
`;

export const DangerTitle = styled(Title)`
  color: ${getColor('error')};
`;

export const SubTitle = styled(Title)`
  font-size: ${ms(11)};
  color: ${p => Color(getColor('text3')(p)).lighten(0.1).toString()};
`;

export const MessageContainer = styled(View)`
  width: 100%;
  margin-top: ${ms(6)};
  padding: ${ms(7)} ${ms(10)} ${ms(8)};
  border-radius: ${ms(10)};
  background-color: ${getColor('background2')};
  align-self: flex-start;
`;

export const Message = styled(Text)`
  font-size: ${ms(13)};
  line-height: ${ms(16)};
  letter-spacing: ${ms(-0.46)};
  color: ${getColor('text1')};
`;

export const ButtonsContainer = styled(View)`
  display: flex;
  flex-direction: column;
  margin-top: ${ms(7)};
  margin-bottom: ${ms(1)};
`;

export const NotificationButton = styled(Button).attrs({
  size: 's',
})`
  margin-bottom: ${ms(4)};
`;

export const Date = styled(Text)`
  font-size: ${ms(13)};
  line-height: ${ms(20)};
  letter-spacing: ${ms(-0.46)};
  color: ${getColor('text3')};
`;
